// METIS Hub wording — namespace "settings" (en), 345 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/settings.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const settings: Record<string, string> = {
  "settings.desc": "Decide what your records keep, see who viewed them, and tune the screen. Every role uses this same page for their own records only.",
  "settings.scopeNote": "Whatever the view scope in the header, this page only handles your own records and consent.",
  "settings.tab.label": "My records & settings",
  "settings.tab.level": "Recording level",
  "settings.tab.views": "Who viewed my records",
  "settings.tab.me": "Profile, alerts & display",
  "settings.st.label": "Current recording state",
  "settings.st.on": "Recording",
  "settings.st.off": "Off",
  "settings.st.recording": "up to {level} · last saved {rel} · {n|PC|PCs} connected",
  "settings.st.recordingCustom": "custom selection · last saved {rel} · {n|PC|PCs} connected",
  "settings.st.noSave": "nothing saved yet",
  "settings.st.paused": "Paused · until {until}",
  "settings.st.reconsent": "Re-consent needed · new records aren’t stored until you agree again",
  "settings.st.withdrawn": "Withdrawn · you can agree again any time",
  "settings.st.before": "Not consented · nothing is stored before you agree",
  "settings.st.pause": "Pause",
  "settings.st.resume": "Resume",
  "settings.st.agree": "Read the notice and agree",
  "settings.st.reagree": "Agree again",
  "settings.re.title": "Please agree to notice {v} again",
  "settings.re.desc": "{changes} Records are not stored until you agree again.",
  "settings.re.act": "See what changed and agree",
  "settings.lv.q": "How much should be recorded?",
  "settings.lv.tech": "Recording level · 4 cumulative steps · company ceiling ∩ your choice",
  "settings.lv.sum": "Recording up to {level}. The company ceiling is {cap}.",
  "settings.lv.sumCustom": "Recording a custom selection ({items}). The company ceiling is {cap}.",
  "settings.lv.sumOff": "Not recording right now ({why}). The company ceiling is {cap}.",
  "settings.lv.pick": "Choose a recording level",
  "settings.lv.cap": "Company ceiling",
  "settings.lv.capAbove": "Above the company ceiling",
  "settings.lv.current": "In effect",
  "settings.lv.adds": "Adds",
  "settings.lv.add.1": "Time, tool, AI model, usage (tokens), duration, success",
  "settings.lv.add.2": "Your question text",
  "settings.lv.add.3": "AI answer text",
  "settings.lv.add.4": "Commands, file paths, changes",
  "settings.lv.frame": "If you choose {level}",
  "settings.lv.f.send": "Sent",
  "settings.lv.f.notSend": "Not sent",
  "settings.lv.f.local": "Stays on your PC only",
  "settings.lv.f.revoke": "How to take it back",
  "settings.lv.1.send": "Time, tool, AI model, usage (tokens), duration, success",
  "settings.lv.1.notSend": "Question text · AI answer text · commands, file paths, changes · the AI’s intermediate thinking",
  "settings.lv.1.local": "Questions, answers and work stay only in the AI tool’s conversation files on your PC.",
  "settings.lv.2.send": "① Basic info + your question text (redacted, then stored encrypted)",
  "settings.lv.2.notSend": "AI answer text · commands, file paths, changes · the AI’s intermediate thinking",
  "settings.lv.2.local": "AI answers and work stay on your PC only.",
  "settings.lv.3.send": "② + AI answer text (Codex answers are an unofficial setting, so some may be missing)",
  "settings.lv.3.notSend": "Commands, file paths, changes · tool output · the AI’s intermediate thinking",
  "settings.lv.3.local": "Commands and file contents stay on your PC only.",
  "settings.lv.4.send": "③ + commands, file paths and changes (paths show only their last two parts)",
  "settings.lv.4.notSend": "Tool output (file contents, command output) · contents of secret files · the AI’s intermediate thinking · keystrokes, screen, network",
  "settings.lv.4.local": "Full file contents and command output stay on your PC only.",
  "settings.lv.revoke": "Lower it, pause, or withdraw any time. Stored text is deleted after the retention period ({days} days); to delete it now, request deletion.",
  "settings.lv.4.warn": "Commands and tool input may contain secrets. Redaction only catches known formats.",
  "settings.lv.change": "Change {from} → {to}?",
  "settings.lv.apply": "Switch to this level",
  "settings.lv.keep": "Keep as is",
  "settings.lv.c4.title": "Record work details too?",
  "settings.lv.c4.body": "Commands, file paths and changes will be kept on the company server. If secrets end up in commands or tool input, redaction may miss them (it only catches known formats).",
  "settings.lv.c4.check": "I understand secrets may be included",
  "settings.lv.c4.need": "Tick the box to turn this on",
  "settings.lv.cd.title": "Lower to {to}?",
  "settings.lv.cd.body": "It applies to records that arrive after the change. Stored text is deleted after the retention period ({days} days); to delete it now, request deletion.",
  "settings.lv.cu.title": "Raise to {to}?",
  "settings.lv.cu.body": "It applies to records that arrive after the change. You can lower it again any time.",
  "settings.lv.changed": "Recording level changed to {to} · added to your consent history",
  "settings.lv.resync.title": "Get your CLI settings again",
  "settings.lv.resync.desc": "For the AI tools on your PC to send at the new level, get and apply the settings again. Until then the server drops items outside your level.",
  "settings.lv.resync.act": "Get settings again",
  "settings.lv.blocked.withdrawn": "You withdrew consent. Agree again to choose a recording level.",
  "settings.lv.blocked.reconsent": "Agree to notice {v} again to change your recording level.",
  "settings.lv.blocked.before": "Agree to the notice to choose a recording level.",
  "settings.lv.note.admin": "The company ceiling is set in Recording policy. Other people’s levels can only be lowered through the ceiling.",
  "settings.lv.note.adminLink": "Open recording policy",
  "settings.lv.note.manager": "Only each teammate can change their own recording level and consent. Managers handle only their own here.",
  "settings.lv.emptyWhat": "You haven’t agreed to recording yet.",
  "settings.lv.emptyNot": "Nothing is stored before you agree. It doesn’t mean you haven’t used AI tools.",
  "settings.adv.toggle": "Choose items (advanced)",
  "settings.adv.custom": "Custom selection",
  "settings.adv.desc": "Turn items on and off one by one. What is actually kept is what both the company ceiling and your choice allow.",
  "settings.adv.basicLocked": "Always on while you consent. To stop, pause or withdraw consent.",
  "settings.item.prompt.d": "Questions you sent to the AI",
  "settings.item.answer.d": "AI answers (Codex answers are an unofficial setting)",
  "settings.item.work_detail.d": "Commands, file paths, changes",
  "settings.item.tool_output.d": "Part of file contents and command output · asks you to confirm the risk",
  "settings.item.server_upload.d": "Uploads records the PC helper collected",
  "settings.adv.changed": "{n|item changed|items changed}",
  "settings.adv.save": "Save these choices",
  "settings.adv.reset": "Undo",
  "settings.adv.saved": "Item choices saved · added to your consent history",
  "settings.adv.riskTitle": "Turn on tool output?",
  "settings.adv.riskBody": "Part of file contents and command output will be kept on the company server. Secrets or personal data may be included, and redaction only catches known formats.",
  "settings.adv.riskCheck": "I understand the risk",
  "settings.adv.riskOn": "Turn on",
  "settings.r.q": "What can I do with my records?",
  "settings.r.tech": "Your rights · pause · copy · deletion request · withdraw consent",
  "settings.r.pause.t": "Pause",
  "settings.r.pause.d": "Pause for an hour, for today, or until a time you choose. Records created while paused aren’t stored, even if they arrive late.",
  "settings.r.pause.now": "Paused until {until}.",
  "settings.r.copy.t": "Get a copy of my records",
  "settings.r.copy.d": "Download your records (text included) without giving a reason. Downloads are kept in the access & change log.",
  "settings.r.copy.btn": "Get a copy",
  "settings.r.del.t": "Request deletion",
  "settings.r.del.d": "Ask to delete one conversation, a period, or everything. Viewing is blocked as soon as you ask.",
  "settings.r.del.btn": "Request deletion",
  "settings.r.wd.t": "Withdraw consent",
  "settings.r.wd.d": "Stops recording and also requests deletion of everything so far. You can agree again any time.",
  "settings.r.wd.btn": "Withdraw consent",
  "settings.r.notice.t": "Notice",
  "settings.r.notice.d": "{v} · published {date} · {agreed}",
  "settings.r.notice.agreed": "agreed {date}",
  "settings.r.notice.need": "needs your agreement again",
  "settings.r.notice.btn": "Read the notice",
  "settings.r.sum": "You agreed to notice {v} on {date}, and no deletion request is waiting.",
  "settings.r.sumPending": "{n|deletion request is|deletion requests are} waiting. Those records are already blocked from viewing.",
  "settings.r.sumNeed": "You haven’t agreed to notice {v} yet.",
  "settings.r.what.t": "What gets recorded?",
  "settings.r.what.d": "See, item by item, what each tool and usage method can and can’t record. What each version can send is in the support table.",
  "settings.r.what.btn": "What gets recorded",
  "settings.r.what.btn2": "Support table",
  "settings.d.list": "My deletion requests",
  "settings.d.st.pending": "Waiting · auto-deleted {due}",
  "settings.d.st.done": "Deleted · {when}",
  "settings.d.st.held": "On hold (legal hold)",
  "settings.d.st.rejected": "Rejected · visible again",
  "settings.d.n": "{n|conversation|conversations}",
  "settings.d.memo": "Note: {m}",
  "settings.d.sc.one": "Conversation #{no}",
  "settings.d.sc.range": "{from}–{to}",
  "settings.d.sc.all": "All records",
  "settings.p.title": "Pause recording?",
  "settings.p.1h": "1 hour",
  "settings.p.1hD": "until {until}",
  "settings.p.today": "Until midnight",
  "settings.p.custom": "Pick a time",
  "settings.p.until": "Resume at",
  "settings.p.hint": "Records created while paused aren’t stored, even if they arrive late. You can resume any time.",
  "settings.p.ok": "Pause",
  "settings.p.done": "Recording paused until {until}",
  "settings.p.resumed": "Recording resumed",
  "settings.c.title": "Get a copy of my records",
  "settings.c.period": "Period",
  "settings.c.p30": "Last 30 days",
  "settings.c.p90": "Last 90 days",
  "settings.c.all": "All",
  "settings.c.format": "Format",
  "settings.c.withText": "Include question & answer text",
  "settings.c.withTextD": "Your own copy can include text (redacted as stored).",
  "settings.c.make": "Make the copy",
  "settings.c.ready": "Your copy is ready · {n|record|records}",
  "settings.c.download": "Download {file}",
  "settings.c.note": "No file is left on the server. The download is kept in the access & change log.",
  "settings.c.empty": "You have no records in this period.",
  "settings.d.title": "Request deletion?",
  "settings.d.scope": "What to delete",
  "settings.d.one": "One conversation",
  "settings.d.range": "A period",
  "settings.d.all": "Everything",
  "settings.d.pick": "Conversation",
  "settings.d.from": "From",
  "settings.d.to": "To",
  "settings.d.invalid": "The start date is after the end date",
  "settings.d.effect": "As soon as you ask, it disappears from every list, detail and total. Operations handles it, or it’s deleted automatically after 7 days. Usage needed for billing stays as pseudonymous totals.",
  "settings.d.allWarn": "Deleting everything removes all your records the server has received so far. Records after you agree again are kept.",
  "settings.d.ok": "Request deletion",
  "settings.d.done": "Deletion requested · viewing is blocked now",
  "settings.d.noConv": "No conversations to choose",
  "settings.w.title": "Withdraw consent?",
  "settings.w.lead": "If you withdraw:",
  "settings.w.r1": "From now on, nothing is stored.",
  "settings.w.r2": "A request to delete all your records so far is created too.",
  "settings.w.r3": "You can agree again any time. Using the AI tools themselves isn’t affected (the company key gateway can’t be used).",
  "settings.w.hold": "Press and hold to withdraw",
  "settings.w.holdHint": "Keep the button pressed for 1.2 seconds. With a keyboard, hold Space or Enter.",
  "settings.w.done": "Consent withdrawn · full deletion requested",
  "settings.w.undoHint": "Undo within {s} seconds to restore your consent and cancel the deletion request",
  "settings.w.undone": "Withdrawal undone · the deletion request was cancelled",
  "settings.n.kicker": "Notice {v} · published {date}",
  "settings.n.title": "About recording your AI use",
  "settings.n.changes": "What changed in this version",
  "settings.n.hash": "Text fingerprint {hash}",
  "settings.n.scroll": "Read to the end to agree",
  "settings.n.end": "End of the notice.",
  "settings.n.agree": "Agree",
  "settings.n.agreed": "You agreed to notice {v} · added to your consent history",
  "settings.n.demo": "Demo state, so the agreement wasn’t saved",
  "settings.pr.q": "How are my records protected?",
  "settings.pr.tech": "Protection summary · policy in effect · redaction check",
  "settings.pr.sum": "In the last 30 days, {list} were redacted before storing.",
  "settings.pr.sumNone": "Nothing was redacted in the last 30 days.",
  "settings.pr.keep": "Kept",
  "settings.pr.notKeep": "Not kept",
  "settings.pr.ret": "Retention",
  "settings.pr.who": "Who can see it",
  "settings.pr.mask": "Redaction check",
  "settings.pr.never": "The AI’s intermediate thinking · full API request/response bodies · keystrokes, screen, network",
  "settings.pr.retLine": "Text {c} days · usage & basic info {u} days · backups up to {b} days",
  "settings.pr.who.self": "You — all your records and text",
  "settings.pr.who.flow": "{roles} — open text only after a reason, re-sign-in and a per-conversation grant. Each view appears in “Who viewed my records”.",
  "settings.pr.who.team": "{roles} — see team usage and per-teammate totals only. No question or answer text.",
  "settings.pr.who.meta": "{roles} — see basic info and totals only. No text.",
  "settings.pr.col.kind": "Redacted",
  "settings.pr.col.d7": "Last 7 days",
  "settings.pr.col.d30": "Last 30 days",
  "settings.pr.secret": "Secret file access (contents not stored)",
  "settings.pr.secretNone": "No secret files were accessed.",
  "settings.pr.limit": "Redaction only catches known formats, so it isn’t perfect.",
  "settings.pr.cond": "last 30 days · my records",
  "settings.pr.n": "",
  "settings.pr.emptyWhat": "No records of yours arrived in the last 30 days.",
  "settings.pr.emptyNot": "No record doesn’t mean no use. Check your consent and connections.",
  "settings.h.q": "When did I agree to what?",
  "settings.h.tech": "My consent history · append-only (can’t be edited or deleted)",
  "settings.h.sum": "You first agreed on {first}; the last change was {last}.",
  "settings.h.sumOne": "You agreed on {first}.",
  "settings.h.col.when": "Time",
  "settings.h.col.what": "What",
  "settings.h.col.level": "Recording level",
  "settings.h.col.notice": "Notice",
  "settings.h.source": "Consent records",
  "settings.h.a.grant": "Agreed",
  "settings.h.a.change": "Changed recording level",
  "settings.h.a.reconsent": "Agreed to the notice again",
  "settings.h.a.pause": "Paused · until {until}",
  "settings.h.a.resume": "Resumed",
  "settings.h.a.custom": "Chose items",
  "settings.h.a.withdraw": "Withdrew consent",
  "settings.h.a.withdraw_undo": "Undid the withdrawal",
  "settings.h.custom": "Custom selection",
  "settings.h.emptyWhat": "No consent history yet.",
  "settings.h.emptyNot": "History starts when you agree to the notice.",
  "settings.v.q": "Who viewed my records?",
  "settings.v.tech": "Text views · individual views · exports · deletions · legal holds",
  "settings.v.sum": "Others opened or handled your records {n|time|times} ({roles}). The latest was {rel}.",
  "settings.v.col.when": "Time",
  "settings.v.col.kind": "What",
  "settings.v.col.who": "Viewer role · reason category",
  "settings.v.col.reason": "Reason",
  "settings.v.col.conv": "Which conversation",
  "settings.v.roleOnly": "We show the viewer’s role instead of their name (questions: privacy officer, privacy@example.com).",
  "settings.v.denied": "Denied · the text wasn’t opened",
  "settings.v.person": "My usage summary (individual view)",
  "settings.v.export": "An export containing my records",
  "settings.v.hold": "Under legal hold",
  "settings.v.del": "Deletion processed",
  "settings.v.filter": "Kind",
  "settings.v.all": "All",
  "settings.v.source": "Access & change log",
  "settings.v.cond": "kept 2 years · roles only",
  "settings.v.emptyWhat": "Nobody has opened your records yet.",
  "settings.v.emptyNot": "If someone opens your text or views you individually, the role, time and reason appear here and you get an alert.",
  "settings.v.emptyNext": "Alert settings",
  "settings.m.q": "Whose records did I open?",
  "settings.m.tech": "My access activity · per-conversation grants · individual views",
  "settings.m.sum": "You opened others’ records {n|time|times}. {open|grant is|grants are} open now.",
  "settings.m.sum2": "Text views {v} · individual views {p} · denied {d}. {open|grant is|grants are} open now.",
  "settings.m.noGrant": "No grant needed (individual view)",
  "settings.m.col.when": "Time",
  "settings.m.col.target": "Target",
  "settings.m.col.cat": "Reason category",
  "settings.m.col.reason": "Reason",
  "settings.m.col.grant": "Grant",
  "settings.m.left": "{min} min left",
  "settings.m.ended": "Ended",
  "settings.m.denied": "Denied",
  "settings.m.person": "Individual view",
  "settings.m.note": "Records you open appear in the owner’s “Who viewed my records” under your role.",
  "settings.m.emptyWhat": "You haven’t opened anyone else’s records yet.",
  "settings.m.emptyNot": "Every time you open text, you give a reason, sign in again and get a per-conversation grant; it all lands here.",
  "settings.a.q": "What does my account look like?",
  "settings.a.tech": "Name, email, team, roles, sign-in method, multi-factor authentication (MFA)",
  "settings.a.name": "Name",
  "settings.a.email": "Email",
  "settings.a.team": "Team",
  "settings.a.roles": "Roles",
  "settings.a.job": "Job",
  "settings.a.login": "Sign-in method",
  "settings.a.login.google": "Google account (allowed domain example.com)",
  "settings.a.login.password": "ID and password",
  "settings.a.mfa": "Multi-factor authentication (MFA)",
  "settings.a.mfa.on": "On · required",
  "settings.a.mfa.onD": "Your role can see text, real names or admin features, so MFA is required ({how}).",
  "settings.a.mfa.google": "Google 2-Step Verification",
  "settings.a.mfa.totp": "authenticator app",
  "settings.a.mfa.off": "Off · optional",
  "settings.a.mfa.offD": "Optional for members. Ask an admin to turn it on.",
  "settings.a.pledge": "Prohibited-use pledge",
  "settings.a.pledge.done": "Acknowledged · asked again if your role changes",
  "settings.a.expires": "expires {date}",
  "settings.a.managed": "Admins change your name, team and roles.",
  "settings.a.sum": "Signed in as {roles} ({how}).",
  "settings.a.sumMfa": "As {roles}, you must use multi-factor authentication.",
  "settings.s.q": "Where am I signed in?",
  "settings.s.tech": "Signed-in places · device, sign-in method, last used",
  "settings.s.sum": "Signed in at {n|place|places}.",
  "settings.s.this": "This browser",
  "settings.s.logout": "Sign out",
  "settings.s.logoutAll": "Sign out everywhere else",
  "settings.s.done": "Signed out on that device",
  "settings.s.doneAll": "Signed out everywhere else",
  "settings.s.last": "last used {rel}",
  "settings.s.now": "now",
  "settings.s.ruleAdmin": "With admin permissions you sign in again after 30 idle minutes or 8 hours.",
  "settings.s.ruleMember": "You sign in again after 2 idle hours or 12 hours.",
  "settings.s.phone": "Phone",
  "settings.s.browser": "{dev} · {br}",
  "settings.nt.q": "Which alerts do I want?",
  "settings.nt.tech": "Alerts · bell at the top and email",
  "settings.nt.conn": "When my device disconnects",
  "settings.nt.connD": "When nothing arrives for over 3 days or an error occurs",
  "settings.nt.viewed": "When my records are viewed",
  "settings.nt.viewedD": "Even if off, every view stays in “Who viewed my records”",
  "settings.nt.token": "When a connection token is about to expire",
  "settings.nt.tokenD": "14 days before it expires",
  "settings.nt.reconsent": "When I need to agree to the notice again",
  "settings.nt.reconsentD": "Can’t be turned off · new records aren’t stored until you agree again",
  "settings.nt.channel": "Delivered to",
  "settings.nt.ch.app": "In-app only",
  "settings.nt.ch.both": "In-app + email",
  "settings.nt.emailUnavailable": "Email alerts are not available yet. Alerts appear in the app.",
  "settings.nt.mailTo": "Emails go to {email}.",
  "settings.nt.saved": "Alert settings changed",
  "settings.nt.sum": "You receive {n} of 4 alerts ({ch}).",
  "settings.nt.recent": "Recent alerts",
  "settings.nt.recentNone": "No recent alerts for you.",
  "settings.ds.q": "How should the screen look?",
  "settings.ds.tech": "Language, theme, number units, text size, wrapping long text",
  "settings.ds.lang": "Language",
  "settings.ds.theme": "Theme",
  "settings.ds.num": "Number units",
  "settings.ds.num.compact": "Short",
  "settings.ds.num.full": "All digits",
  "settings.ds.font": "Text size",
  "settings.ds.font.m": "Normal",
  "settings.ds.font.l": "Large",
  "settings.ds.font.xl": "Extra large",
  "settings.ds.wrap": "Wrap long text",
  "settings.ds.wrapD": "Fold long commands and changes to the screen width",
  "settings.ds.preview": "Preview",
  "settings.ds.sample": "My usage (tokens), last 7 days",
  "settings.ds.sampleCmd": "My recent command",
  "settings.ds.local": "Number units, text size and wrapping are saved in this browser only. In the mockup they apply to the preview below first.",
  "settings.ds.saved": "Display settings saved",
  "settings.ds.sum": "Now viewing in {lang} · {theme} theme · number units “{num}”.",
};

export default settings;
